export default __webpack_public_path__ + "static/media/vector_bottom.82650c90.png";